/**
 * 金额换算与展示。
 *
 * 背景：后端账本单位是整数 unit（1e-8 美元）；用户看到的是花瓣（1 美元 = 1,000 花瓣，沿用现有 Asterove），
 *   运营看价格时还要看美元与「每百万 Token」单价。
 * 关键约束：输入框里的花瓣、美元换回 unit 时四舍五入到整数，不把浮点数发给后端。
 */

export const UNITS_PER_USD = 100_000_000
export const UNITS_PER_PETAL = 100_000

export function petals(units: number): number {
  return units / UNITS_PER_PETAL
}

export function petalsToUnits(p: number): number {
  return Math.round(p * UNITS_PER_PETAL)
}

export function usdToUnits(usd: number): number {
  return Math.round(usd * UNITS_PER_USD)
}

export function fmtPetals(units: number, locale = 'en'): string {
  const v = units / UNITS_PER_PETAL
  return v.toLocaleString(locale, { maximumFractionDigits: Math.abs(v) < 10 ? 3 : 2 })
}

export function fmtUsd(units: number, locale = 'en', digits = 2): string {
  return (units / UNITS_PER_USD).toLocaleString(locale, {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: digits,
    maximumFractionDigits: Math.max(digits, 6),
  })
}

/** 订单金额（最小货币单位）转展示。 */
export function fmtMinor(minor: number, currency: string, locale = 'en'): string {
  const c = currency.toUpperCase()
  const digits = c === 'KRW' || c === 'JPY' ? 0 : 2
  return (minor / 10 ** digits).toLocaleString(locale, { style: 'currency', currency: c })
}

export function fmtInt(n: number, locale = 'en'): string {
  return n.toLocaleString(locale)
}
